// Views ViewManager renders with NamesView or ExploreView
export const INDEX_EXPLORE_VIEWS = new Set(['index', 'fullText', 'explore', 'organize'])

// Views whose page calls useAllowDarkMode
export const DARK_MODE_VIEWS = new Set([...INDEX_EXPLORE_VIEWS, 'debug'])

// ViewManager sets this view on mount when the URL has none
export const DEFAULT_VIEW = 'index'
